<template>
    <footer class="rtb-form-footer">
        <p v-if="generalError" class="form-error" role="alert">{{ generalError }}</p>
        <div class="rtb-form-footer__actions">
            <button
                v-if="canWrite"
                type="submit"
                class="btn btn--primary"
                :disabled="!canSubmit || busy"
            >
                {{ busy && !asDraft ? 'Сохранение…' : (isEdit ? 'Сохранить' : 'Создать кампанию') }}
            </button>
            <button
                v-if="canWrite && showDraft"
                type="button"
                class="btn btn--secondary"
                :disabled="!canDraft || busy"
                @click="emit('draft')"
            >
                {{ busy && asDraft ? 'Сохранение…' : 'Сохранить черновик' }}
            </button>
            <button
                v-if="canWrite"
                type="button"
                class="btn btn--secondary"
                :disabled="busy || exporting"
                @click="emit('export-settings')"
            >
                {{ exporting ? 'Выгрузка…' : 'Скачать настройки' }}
            </button>
            <button type="button" class="btn btn--secondary" :disabled="busy" @click="emit('cancel')">
                {{ canWrite ? 'Отмена' : 'Назад' }}
            </button>
        </div>
    </footer>
</template>

<script setup>
defineProps({
    canWrite: { type: Boolean, default: true },
    canSubmit: { type: Boolean, default: false },
    canDraft: { type: Boolean, default: false },
    showDraft: { type: Boolean, default: true },
    isEdit: { type: Boolean, default: false },
    busy: { type: Boolean, default: false },
    asDraft: { type: Boolean, default: false },
    exporting: { type: Boolean, default: false },
    generalError: { type: String, default: '' },
});

const emit = defineEmits(['draft', 'export-settings', 'cancel']);
</script>
